<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form" class="h-100">
            <v-row class="h-100" no-gutters>
                <v-col xl="10" lg="9" md="8" order-md="0" order="1" cols="12" class="px-3 h-100 d-flex flex-column">
                    <v-text-field
                        :rules="$validation('required')"
                        label="* عنوان مقاله ..."
                        variant="outlined"
                        class="flex-grow-0"
                        v-model="form.name"
                    ></v-text-field>
                    <div class="d-flex justify-space-between align-center mb-2">
                        <v-btn variant="text" color="secondary" @click="$refs.templateDialog.dialog = true">
                            <v-icon class="me-2" color="secondary" size="18">icon-template</v-icon>قالب‌های آماده
                        </v-btn>
                        <v-btn variant="text" color="secondary" @click="showSEO = !showSEO">
                            <v-icon class="me-2" color="secondary" size="18">{{ showSEO ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>تنظیمات سئو
                        </v-btn>
                    </div>
                    <v-expand-transition>
                        <div v-show="showSEO" class="pt-2 px-1 flex-shrink-0">
                            <v-text-field
                                :rules="$validation()"
                                label="Slug"
                                v-model="form.slug"
                                hide-details
                                class="mb-3"
                            ></v-text-field>
                            <v-text-field
                                :rules="$validation()"
                                label="Meta Description"
                                v-model="form.meta"
                                hide-details
                                class="mb-3"
                            ></v-text-field>
                        </div>
                    </v-expand-transition>
                    <ckeditor full class="flex-grow-1 overflow-hidden" v-model="form.body" ref="ckeditor"></ckeditor>
                    <div class="mt-4">
                        <v-btn color="success" :loading="loading" type="submit">{{ form.status == oldStatus ? 'ثبت اطلاعات' : form.status == 'draft' ? 'ذخیره به صورت پیش نویس' : 'انتشار مقاله'}}</v-btn>
                        <v-btn class="ms-3" variant="text" color="error" @click="$router.push({path: '/knowledgeBaseArticles'});" :disabled="loading">بازگشت</v-btn>
                    </div>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col xl="2" lg="3" md="4" sm="7" class="mx-md-0 mx-auto text-center px-3 h-100 overflow-y-auto">
                    <v-btn color="secondary" class="mb-3" @click="preview" v-if="oldStatus">
                        <v-icon color="white" size="17" class="me-2">icon-relatedarticles</v-icon>{{ oldStatus == 'published' ? 'مشاهده مقاله' : 'مشاهده پیش‌نمایش' }}
                    </v-btn>
                    <div class="d-flex align-center mx-auto text-secondary text-small mt-2 mb-1 font-weight-medium"><v-divider color="secondary" class="border-opacity-100"></v-divider><span class="bg-white text-secondary flex-shrink-0 px-2">گزارشات آماری</span><v-divider color="secondary" class="border-opacity-100"></v-divider></div>
                    <div class="d-flex align-center justify-space-around">
                        <div>
                            <v-icon color="secondary" size="22">icon-eye</v-icon>
                            <h3 class="mt-3 text-grey font-weight-medium user-select-none">{{ form.views }}</h3>
                        </div>
                        <v-divider vertical class="my-4" color="secondary"></v-divider>
                        <div>
                            <v-icon color="green" size="22">icon-like</v-icon>
                            <h3 class="mt-3 text-grey font-weight-medium user-select-none">{{ form.likes }}</h3>
                        </div>
                        <v-divider vertical class="my-4" color="secondary"></v-divider>
                        <div>
                            <v-icon color="red" size="22">icon-dislike</v-icon>
                            <h3 class="mt-3 text-grey font-weight-medium user-select-none">{{ form.dislikes }}</h3>
                        </div>
                    </div>
                    <div class="d-flex align-center mx-auto text-secondary text-small mt-1 mb-5 font-weight-medium"><v-divider color="secondary" class="border-opacity-100"></v-divider><span class="bg-white text-secondary flex-shrink-0 px-2">تنظیمات مقاله</span><v-divider color="secondary" class="border-opacity-100"></v-divider></div>
                    <v-select
                        :rules="$validation('required')"
                        :items="[{ name: 'انتشار یافته', id: 'published' }, { name: 'پیش‌ نویس', id: 'draft' }]"
                        item-title="name"
                        item-value="id"
                        no-data-text="موردی پیدا نشد!"
                        label="وضعیت"
                        v-model="form.status"
                    ></v-select>
                    <div class="d-flex align-center">
                        <v-select
                            :rules="$validation('required')"
                            :items="$system.kbArticleCategories"
                            item-title="name"
                            item-value="id"
                            no-data-text="موردی پیدا نشد!"
                            label="* دسته‌بندی مقاله"
                            v-model="form.knowledge_base_category_id"
                        ></v-select>
                        <v-btn icon="icon-add" size="small" color="secondary" class="mb-6 ms-1" @click="$refs.addArticleCategory.articleCategoryDialog = true; $refs.addArticleCategory.editCategory = false; $refs.addArticleCategory.form = {name:null, parent_id:null, status:false, description:null};"></v-btn>
                    </div>
                    <v-select
                        :rules="$validation()"
                        :items="[{name: 'عمومی',id: true},{name: 'خصوصی',id: false}]"
                        item-title="name"
                        item-value="id"
                        label="سطح دسترسی مقاله"
                        no-data-text="موردی پیدا نشد!"
                        v-model="form.public"
                        @update:modelValue="form.user_group = null"
                    ></v-select>
                    <v-select
                        :rules="$validation('required:' + (form.public ? 0 : 1))"
                        :items="[{name:'کاربران سازمانی',id:'employees'},{name:'مشتریان',id:'customers'},{name:'کاربران سازمانی و مشتریان',id:'both'}]"
                        :disabled="form.public"
                        item-title="name"
                        item-value="id"
                        label="* کاربران مجاز برای دیدن مقاله"
                        v-model="form.user_group"
                    ></v-select>
                    <v-text-field
                        :rules="$validation()"
                        label="مدت زمان مطالعه"
                        v-model="form.read_time"
                        suffix="دقیقه"
                    ></v-text-field>
                    <tag-input v-model="tags" type="knowledgebaseArticle" label="برچسب ها" :id="$route.params.id"></tag-input>
                    <v-btn
                        class="text-secondary"
                        color="secondary"
                        block
                        variant="tonal"
                        :disabled="!form.user_group && !form.public"
                        @click="$refs.relatedArticleDialog.openDialog()"
                    >
                        <v-icon size="18" class="me-2">icon-relatedarticles</v-icon>مقالات مرتبط
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <related-article-dialog ref="relatedArticleDialog"></related-article-dialog>
        <template-dialog ref="templateDialog" @submited="body => $refs.ckeditor.insertContent(body)"></template-dialog>
        <add-article-category ref="addArticleCategory"></add-article-category>
    </div>
</template>
<script>
export default {
    title: "ویرایش",
    validate(context) {
        return context.system.license.features.kb_core && context.rbac.can('manage knowledge base');
    },
    data() {
        return {
            loading: false,
            showSEO: false,
            oldStatus: null,
            form:{
                name:null,
                body:'',
                knowledge_base_category_id:null,
                public:false,
                user_group:null,
                read_time:null,
                slug:null,
                meta:null,
                status:null,
                likes:'-',
                dislikes:'-',
                views:'-',
                related_articles:[],
            },
            tags: [],
        };
    },
    methods: {
        submit(){
            if(!this.form.body.replace(/<[^>]*>?/gm, ""))
                this.$toast.error('متن مقاله اجباری می‌باشد.')
            else{
                this.loading = true;
                let form = {...this.form};
                if(form.public)
                    delete form.user_group
                form.related_articles = this.$refs.relatedArticleDialog?.choosenList?.map(x => x.id) ?? [];
                this.$knowledgebaseArticleUpdate(this.$route.params.id, form).then(res=>{
                    if(res && res.status == "UPDATED") {
                        this.$toast.success('عملیات با موفقیت انجام شد.');
                        this.oldStatus = this.form.status;
                    }
                }).finally(()=>{this.loading = false})
            }
        },
        preview(){
            window.open(`/kb/articles/${this.$route.params.id}/${this.form.slug}`, '_blank')
        },
        async getArticle(){
            await this.$knowledgebaseArticleGet(this.$route.params.id).then(res=>{
                if(res && res.status == "OK"){
                    let form = {...res.data};
                    form.body = form.body ?? '';
                    this.tags = form.tags;
                    this.$refs.relatedArticleDialog.choosenList = form.related_articles;
                    delete form.related_articles;
                    delete form.tags;
                    delete form.created_at;
                    delete form.updated_date;
                    this.oldStatus = form.status;
                    Object.keys(form).forEach(el => {
                        if (form[el] === null)
                            form[el] = el == 'status' ? 'draft' : null;
                    });
                    this.form = form;
                }
            })
        }
    },
    mounted() {
        this.$nextTick(async()=>{
            this.$loading.start();
            await this.getArticle();
            this.$loading.finish();
        })
    },
};
</script>
